import { SecuredClient } from 'Core/Api/SecuredClient';
import {
    GetAllAdminsByFilterCommandRequest,
    GetAllAdminsByFilterCommandResponse,
    SlimAdministrator,
    AddAdminUserCommandResponse,
    GetAllRolesByFilterCommandResponse,
} from '../../../Core/Api/Api';

export interface AddAdminRequest {
    userName: string;
    firstName: string;
    lastName: string;
    emailAddress: string;
    phoneNumber: string;
    password: string;
    accessCards: string[];
    adminStatus: string;
    isSeniorAdmin: boolean;
}

export interface GetAdminByUserIdResponse {
    success: boolean;
    administrator: SlimAdministrator;
}

export interface UpdateAdminUserRequest {
    userId: string;
    firstName: string;
    lastName: string;
    emailAddress: string;
    phoneNumber: string;
    accessCards: string[];
    adminStatus: string;
    isSeniorAdmin: boolean;
}

export interface UpdateAdminUserResponse {
    success: boolean;
    administrator: SlimAdministrator;
}

export interface DeleteAdminUserRequest {
    userId: string;
}

export interface DeleteAdminUserResponse {
    success: boolean;
}

export class AdministratorHandler {
    constructor(props?: any) { }

    async GetData(request: GetAllAdminsByFilterCommandRequest): Promise<GetAllAdminsByFilterCommandResponse> {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;

        try {
            const response = await client.getAdminsByFilter(request);
            return response;
        } catch (error) {
            console.error('Error fetching administrators:', error);
            throw error;
        }
    }

    async addAdminUser(request: AddAdminRequest): Promise<AddAdminUserCommandResponse> {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;

        try {
            const url = `${(client as any).baseUrl}/sa/sudokuvs/admin/commands/AddAdminUser`;
            const content = JSON.stringify(request);
            const response = await client.axiosInstance.request({
                data: content,
                method: 'POST',
                url,
                headers: {
                    'Content-Type': 'application/json-patch+json',
                    'Accept': 'text/plain',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error adding admin user:', error);
            throw error;
        } finally {
            client.showLoading = false;
        }
    }

    async getRoles(): Promise<GetAllRolesByFilterCommandResponse> {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;

        try {
            return await client.getAllRoles();
        } catch (error) {
            console.error('Error fetching roles:', error);
            throw error;
        } finally {
            client.showLoading = false;
        }
    }

    async getAdminByUserId(userId: string): Promise<GetAdminByUserIdResponse> {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;

        const url = `${(client as any).baseUrl}/sa/sudokuvs/admin/commands/GetAdminByUserId?UserId=${encodeURIComponent(userId)}`;
        const response = await client.axiosInstance.request({
            method: 'GET',
            url,
            headers: { 'Accept': 'text/plain' },
        });
        return response.data;
    }

    async updateAdminUser(request: UpdateAdminUserRequest): Promise<UpdateAdminUserResponse> {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;

        const url = `${(client as any).baseUrl}/sa/sudokuvs/admin/commands/UpdateAdminUser`;
        const content = JSON.stringify(request);
        const response = await client.axiosInstance.request({
            data: content,
            method: 'POST',
            url,
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Accept': 'text/plain',
            },
        });
        return response.data;
    }

    async deleteAdminUser(request: DeleteAdminUserRequest): Promise<DeleteAdminUserResponse> {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;

        const url = `${(client as any).baseUrl}/sa/sudokuvs/admin/commands/DeleteAdminUser`;
        const content = JSON.stringify(request);
        const response = await client.axiosInstance.request({
            data: content,
            method: 'POST',
            url,
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Accept': 'text/plain',
            },
        });
        return response.data;
    }
}